import { useState } from "react";

// Components
import ProviderAuthenticator from "./ProviderAuthenticator";
import AuthenticatorDialog from "../AuthenticatorDialog";

// Types
import { TGetProviderList } from "@/Settings/api/AdministrationTools/queries";
import { IIntegrationProvider } from "@/Settings/types/administrationTools/model";

interface IProviderAuthenticatorItemProps {
	index: number;
	locationId: string | undefined;
	timezone: string;
	selectedProvider: TGetProviderList | undefined;
	providersOptions: TGetProviderList[];
	payrollProvider: IIntegrationProvider;
	isLoading: boolean;
	isLastItem: boolean;
	disabledOptions: string[];
	shouldDisableDeleteProvider: boolean;
	isProviderLimitReached: boolean;
	handleAddProvider: () => void;
	handleDeleteProvider: (index: number) => void;
	handleUpdateSelectedProviders: (index: number, updatedProvider: TGetProviderList) => void;
	handleDeleteAwaitingAccount: (providerName: string, displayId: string) => void;
}

const ProviderAuthenticatorItem = (props: IProviderAuthenticatorItemProps) => {
	const {
		index,
		locationId,
		timezone,
		selectedProvider,
		providersOptions,
		payrollProvider,
		isLoading,
		isLastItem,
		disabledOptions,
		shouldDisableDeleteProvider,
		isProviderLimitReached,
		handleAddProvider,
		handleDeleteProvider,
		handleUpdateSelectedProviders,
		handleDeleteAwaitingAccount,
	} = props;

	const [isAuthDialogOpen, setIsAuthDialogOpen] = useState(false);

	const handleClickPayrollAuthenticate = () => {
		setIsAuthDialogOpen(true);
	};

	const handleCloseAuthDialog = () => {
		setIsAuthDialogOpen(false);
	};

	return (
		<>
			<ProviderAuthenticator
				index={index}
				selectedProvider={selectedProvider}
				providerOptions={providersOptions ?? []}
				payrollProvider={payrollProvider}
				isLoading={isLoading}
				shouldDisableDeleteProvider={shouldDisableDeleteProvider}
				onAdd={handleAddProvider}
				onDelete={() => handleDeleteProvider(index)}
				isLastItem={isLastItem}
				isProviderLimitReached={isProviderLimitReached}
				onOpenAuthenticateDialog={handleClickPayrollAuthenticate}
				onUpdate={handleUpdateSelectedProviders}
				disabledOptions={disabledOptions}
				onDeleteAwaitingAccount={handleDeleteAwaitingAccount}
				timezone={timezone}
			/>
			<AuthenticatorDialog
				locationId={locationId}
				isOpen={isAuthDialogOpen}
				onClose={handleCloseAuthDialog}
				selectedProvider={selectedProvider}
				payrollProvider={payrollProvider}
			/>
		</>
	);
};

export default ProviderAuthenticatorItem;
